import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Operador, Atributo } from 'app/components/caixa/pesquisa-caixa-avancada/pesquisa-caixa-avancada.component';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BuscarExpurgoService } from './buscar-expurgo.service';

@Component({
  selector: 'app-buscarExpurgo',
  templateUrl: './buscarExpurgo.component.html',
  styleUrls: ['./buscarExpurgo.component.scss']
})
export class BuscarExpurgoComponent implements OnInit {

  public clientes: ClienteModel[];
  nomeClienteSelecionado;
  clientePesquisado;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  inputPesquisa = false;
  pesquisaForm: FormGroup;
  pesquisaFormArray: FormArray;
  disabled = ['string'];
  loading = true;
  exportRelatorio = true;
  exportContent;

  operadorGeral: Operador[] = [
    {operador: 'igual', value: 'igual'},
    {operador: 'contenha', value: 'contenha'},
    {operador: 'comece com', value: 'comeceCom'},
    {operador: 'termine com', value: 'termineCom'},
  ];

  operadorIgual: Operador[] = [
    {operador: 'igual', value: 'igual'}
  ];

  operadorData: Operador[] = [
    {operador: 'igual', value: 'igual'},
    {operador: 'maior que', value: 'maiorque'},
    {operador: 'menor que', value: 'menorque'},
  ];

  status = new Array<Atributo>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['rgCaixa', 'nrCaixa', 'areaCaixa', 'tipoId','nomeTipo','nomeCliente','numDocInicial','numDocFinal','dataInicial','dataFinal',
  'origem','qtdTempo','acervoCorrente','acervoIntermediario','temporalidade','indexacao','dataDestruicao','situacaoEnum','destinacaoEnum','legislacao'];
  dataSource = new MatTableDataSource<any>();

  constructor(private router: Router,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    private formBuilder: FormBuilder,
    sanitizer: DomSanitizer,
    private expurgoService: BuscarExpurgoService,
    private dialog: MatDialog) {

      let qtdTempo = new Atributo();
      qtdTempo.descricao = 'Qtd. Tempo';
      qtdTempo.valor = 'qtdTempo';
      qtdTempo.operador = this.operadorGeral;
      qtdTempo.tipo = 'string';

      let acervoCorrente = new Atributo();
      acervoCorrente.descricao = 'Acervo Corrente';
      acervoCorrente.valor = 'acervoCorrente';
      acervoCorrente.operador = this.operadorGeral;
      acervoCorrente.tipo = 'string';

      let acervoIntermediario = new Atributo();
      acervoIntermediario.descricao = 'Acervo Intermediário';
      acervoIntermediario.valor = 'acervoIntermediario';
      acervoIntermediario.operador = this.operadorGeral;
      acervoIntermediario.tipo = 'string';

      let temporalidadeTotal = new Atributo();
      temporalidadeTotal.descricao = 'Temporalidade Total';
      temporalidadeTotal.valor = 'temporalidadeTotal';
      temporalidadeTotal.operador = this.operadorGeral;
      temporalidadeTotal.tipo = 'string';

      let dataDestruicao = new Atributo();
      dataDestruicao.descricao = 'Data Destruição';
      dataDestruicao.valor = 'dataDestruicao';
      dataDestruicao.operador = this.operadorData;
      dataDestruicao.tipo = 'date';

      let situacaoDoc = new Atributo();
      situacaoDoc.descricao = 'Situação Documental';
      situacaoDoc.valor = 'situacaoDoc';
      situacaoDoc.operador = this.operadorIgual;
      situacaoDoc.tipo = 'string';

      let destinacaoDoc = new Atributo();
      destinacaoDoc.descricao = 'Destinação Documental';
      destinacaoDoc.valor = 'destinacaoDoc';
      destinacaoDoc.operador = this.operadorIgual;
      destinacaoDoc.tipo = 'string';

      let indexacao = new Atributo();
      indexacao.descricao = 'Indexação';
      indexacao.valor = 'indexacao';
      indexacao.operador = this.operadorGeral;
      indexacao.tipo = 'string';

      let legislacao = new Atributo();
      legislacao.descricao = 'Legislação';
      legislacao.valor = 'legislacao';
      legislacao.operador = this.operadorGeral;
      legislacao.tipo = 'string';

      let rgCaixa = new Atributo();
      rgCaixa.descricao = 'RG Caixa';
      rgCaixa.valor = 'rgCaixa';
      rgCaixa.operador = this.operadorGeral;
      rgCaixa.tipo = 'string';

      let nrCaixa = new Atributo();
      nrCaixa.descricao = 'Nr. Caixa';
      nrCaixa.valor = 'nrCaixa';
      nrCaixa.operador = this.operadorGeral;
      nrCaixa.tipo = 'string';

      let nrDocInicial = new Atributo();
      nrDocInicial.descricao = 'Nr. Doc. Inicial';
      nrDocInicial.valor = 'nrDocInicial';
      nrDocInicial.operador = this.operadorGeral;
      nrDocInicial.tipo = 'string';

      let nrDocFinal = new Atributo();
      nrDocFinal.descricao = 'Nr. Doc. Final';
      nrDocFinal.valor = 'nrDocFinal';
      nrDocFinal.operador = this.operadorGeral;
      nrDocFinal.tipo = 'string';

      let descricaoConteudo = new Atributo();
      descricaoConteudo.descricao = 'Descrição Conteúdo';
      descricaoConteudo.valor = 'descricaoConteudo';
      descricaoConteudo.operador = this.operadorGeral;
      descricaoConteudo.tipo = 'string';

      let origem = new Atributo();
      origem.descricao = 'Origem';
      origem.valor = 'origem';
      origem.operador = this.operadorGeral;
      origem.tipo = 'string';

      let nomeCliente = new Atributo();
      nomeCliente.descricao = 'Nome Cliente';
      nomeCliente.valor = 'nomeCliente';
      nomeCliente.operador = this.operadorGeral;
      nomeCliente.tipo = 'string';

      let dataInicial = new Atributo();
      dataInicial.descricao = 'Data Inicial';
      dataInicial.valor = 'dataInicial';
      dataInicial.operador = this.operadorGeral;
      dataInicial.tipo = 'date';

      let dataFinal = new Atributo();
      dataFinal.descricao = 'Data Final';
      dataFinal.valor = 'dataFinal';
      dataFinal.operador = this.operadorGeral;
      dataFinal.tipo = 'date';

      this.status.push(qtdTempo, acervoCorrente, acervoIntermediario, temporalidadeTotal, dataDestruicao, situacaoDoc, destinacaoDoc, indexacao, legislacao,
        rgCaixa, nrCaixa, nrDocInicial, nrDocFinal, descricaoConteudo, origem, nomeCliente, dataInicial, dataFinal);
    }

  ngOnInit() {
    this.listarClientesUsuario();
    this.pesquisaForm = this.formBuilder.group({
      pesquisaFormArray: this.formBuilder.array([ this.createItem() ])
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    }, () => {
      this.loading = false;
    });
  }

  onChange(indice) {
    this.desabilitarOperador(indice);
  }

  addItem() {
    this.disabled.push('string');
    this.pesquisaFormArray = this.pesquisaForm.get('pesquisaFormArray') as FormArray;
    this.pesquisaFormArray.push(this.createItem());
  }

  remover(indice: any) {
    if (indice > 0) {
      this.pesquisaFormArray.removeAt(indice);
      this.disabled.splice(indice, 1);
    }else {
      this.openSnackBarError('Erro ao remover. O primeiro filtro é obrigatório !');
    }
  }

  desabilitarOperador(indice) {
    const group = this.pesquisaForm.get('pesquisaFormArray').value[indice];
    const arrayGroup = ['dataInicial', 'dataFinal','dataDestruicao'];
    const arrayGroupNumber = ['numeroDoc']
    if (arrayGroup.includes(group.atributo)) {
      this.disabled[indice] = 'date';
    } else if (arrayGroupNumber.includes(group.atributo))  {
      this.disabled[indice] = 'number'
    }
    else if (group.atributo === 'situacaoDoc') {
      this.disabled[indice] = 'enum1';
    }
    else if (group.atributo === 'destinacaoDoc') {
      this.disabled[indice] = 'enum2';
    }
    else {
      this.disabled[indice] = 'string';
    }
  }

  onSearch() {
    let selectedNumber = (<HTMLSelectElement>document.getElementById('selectCliente')).options.selectedIndex;
    this.nomeClienteSelecionado = (<HTMLSelectElement>document.getElementById('selectCliente')).options[selectedNumber].innerText;
    let value = (<HTMLSelectElement>document.getElementById('selectCliente')).value;
    this.clientePesquisado = parseInt(value);
    this.inputPesquisa = true;
    if(parseInt(value) == 0) {
      this.openSnackBarError('Nenhum Cliente selecionado !');
      return null;
    }
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      atributo: ['', [Validators.required]],
      operador: ['', Validators.required],
      conteudo: ['', [Validators.required]]
    });
  }

  getAllDocsFunction() {
    this.expurgoService.getAllDocs().subscribe(data => {
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

  pesquisaAvancada() {
    this.loading = true;
    const arrayPesquisa = this.pesquisaForm.get('pesquisaFormArray').value;
    this.expurgoService.searchSituacaoDoc(arrayPesquisa, this.clientePesquisado).subscribe(data => {
      // data.length > 0 ? this.exportRelatorio = false : this.exportRelatorio = true;
      if (data.length > 0) {
        this.exportRelatorio = false;
        this.exportContent = data;
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      } else {
        this.exportRelatorio = true;
        this.exportContent = null;
        this.openSnackBarError('Nenhuma informação documental encontrada !');
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  downloadRelatorio() {
    this.loading = true;
    this.expurgoService.downloadRelatorio(this.exportContent).subscribe(data => {
      this.downloadFile(data);
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    })
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName: string = `relatorio-eliminacao-${this.nomeClienteSelecionado}.xlsx`;
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

   // SnackBares
   openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/buscarExpurgo/buscarExpurgo.component.ts